module.exports = __webpack_public_path__ + "img/symbol_4.0c0ea542.png";